import React, { Component } from 'react';
import { Checkbox, Stack } from 'office-ui-fabric-react'
import { MyContext } from '../../../context';

const checkboxStyles = () => {
    return {
        root: {
            marginTop: '10px'
        }
    };
};
class VisibilityDetails extends Component {

    static contextType = MyContext;

    render() {

        return (
            <div>
                {this.props.data !== undefined && <Stack vertical>
                    <Checkbox
                        label={this.context.getTranslation("configuration", 'replayVisibilityDetails')}
                        checked={this.props.data.replayVisibilityDetails}
                        styles={checkboxStyles}
                        onChange={(event, newValue) => {
                            this.props.updateField("replayVisibilityDetails", newValue)

                            this.props.updateField("replayVisibilityDetailsTranscript", !newValue)
                            this.props.updateField("replayVisibilityDetailsAnalyticsChange", !newValue)
                            this.props.updateField("replayVisibilityDetailsAnalytics", !newValue)
                            this.props.updateField("replayVisibilityDetailsNotes", !newValue)
                            this.props.updateField("replayVisibilityDetailsTTL", !newValue)
                            this.props.updateField("replayVisibilityDetailsCustomFields", !newValue)
                            this.props.updateField("replayVisibilityDetailsMetadata", !newValue)
                            this.props.updateField("replayVisibilityCleanUp", !newValue)
                            this.props.updateField("replayVisibilityExport", !newValue)
                            this.props.updateField("visibilityDetailsQM", !newValue)
                            this.props.updateField("replayVisibilityDetailsReplay", !newValue)
                        }
                        }
                    />
                    {this.props.data.replayVisibilityDetails && <div style={{ marginLeft: "15px" }}>
                        <div style={{ marginBottom: 10, marginTop: 5 }}>{this.context.getTranslation('configuration', 'visibilityCSFolderPanelLabel')}</div>
                        <Checkbox
                            label={this.context.getTranslation("configuration", 'replayVisibilityDetailsTranscript')}
                            checked={this.props.data.replayVisibilityDetailsTranscript}
                            styles={checkboxStyles}
                            onChange={(event, newValue) => {
                                this.props.updateField("replayVisibilityDetailsTranscript", newValue)
                            }
                            }
                        />
                        <Checkbox
                            label={this.context.getTranslation("configuration", 'replayVisibilityDetailsAnalyticsChange')}
                            checked={this.props.data.replayVisibilityDetailsAnalyticsChange}
                            onChange={(event, newValue) => {
                                this.props.updateField("replayVisibilityDetailsAnalyticsChange", newValue)
                            }
                            }
                        />
                        <Checkbox
                            label={this.context.getTranslation("configuration", 'replayVisibilityDetailsAnalytics')}
                            checked={this.props.data.replayVisibilityDetailsAnalytics}
                            onChange={(event, newValue) => {
                                this.props.updateField("replayVisibilityDetailsAnalytics", newValue)
                            }
                            }
                        />
                        <Checkbox
                            label={this.context.getTranslation("configuration", 'replayVisibilityDetailsNotes')}
                            checked={this.props.data.replayVisibilityDetailsNotes}
                            onChange={(event, newValue) => {
                                this.props.updateField("replayVisibilityDetailsNotes", newValue)
                            }
                            }
                        />
                        <Checkbox
                            label={this.context.getTranslation("configuration", 'replayVisibilityDetailsTTL')}
                            checked={this.props.data.replayVisibilityDetailsTTL}
                            onChange={(event, newValue) => {
                                this.props.updateField("replayVisibilityDetailsTTL", newValue)
                            }
                            }
                        />
                        <Checkbox
                            label={this.context.getTranslation("configuration", 'replayVisibilityDetailsCustomFields')}
                            checked={this.props.data.replayVisibilityDetailsCustomFields}
                            onChange={(event, newValue) => {
                                this.props.updateField("replayVisibilityDetailsCustomFields", newValue)
                            }
                            }
                        />
                        <Checkbox
                            label={this.context.getTranslation("configuration", 'replayVisibilityDetailsMetadata')}
                            checked={this.props.data.replayVisibilityDetailsMetadata}
                            onChange={(event, newValue) => {
                                this.props.updateField("replayVisibilityDetailsMetadata", newValue)
                            }
                            }
                        />
                        <Checkbox
                            label={this.context.getTranslation("configuration", 'replayVisibilityCleanUp')}
                            checked={this.props.data.replayVisibilityCleanUp}
                            onChange={(event, newValue) => {
                                this.props.updateField("replayVisibilityCleanUp", newValue)
                            }
                            }
                        />
                        <Checkbox
                            label={this.context.getTranslation("configuration", 'replayVisibilityExport')}
                            checked={this.props.data.replayVisibilityExport}
                            onChange={(event, newValue) => {
                                this.props.updateField("replayVisibilityExport", newValue)
                            }
                            }
                        />
                        {this.props.userRules.addOnQualityManagement &&
                            < Checkbox
                                label={this.context.getTranslation("compliance", 'AIQM')}
                                checked={this.props.data.visibilityDetailsQM}
                                onChange={(event, newValue) => {
                                    this.props.updateField("visibilityDetailsQM", newValue)
                                }
                                }
                            />}
                        <Checkbox
                            label={this.context.getTranslation("configuration", 'replayVisibilityDetailsReplay')}
                            checked={this.props.data.replayVisibilityDetailsReplay}
                            onChange={(event, newValue) => {
                                this.props.updateField("replayVisibilityDetailsReplay", newValue)
                            }
                            }
                        />
                    </div>}
                </Stack>}
            </div>
        );
    }
}

export default VisibilityDetails;
